<ng-container *ngIf="datos.opcion == 'mover'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_MOVE_PREG'|translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_INTS_SELEC_SECC_MOVE'|translate}}</p>
    <p><b>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_NOT_PREG_MOVE1' |translate}}</b>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_NOT_PREG_MOVE2'|translate}}</p>
    <mat-list>
      <ng-container *ngFor="let seccion of datos.secciones;let i = index; last as last">
        <mat-list-item *ngIf="i != datos.indiceSeccion">
          <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
          <mat-list-item>
            <ng-container *ngFor="let idioma of seccion.sectionsLanguages;">
              <ng-container *ngIf="idioma.lang == idiomaNativo">
                <button mat-raised-button (click)="salir(i)">
                  {{idioma.textSection}}
                  <mat-icon class="ml-20">send</mat-icon>
                </button>
              </ng-container>
            </ng-container>
          </mat-list-item>
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </mat-dialog-content>
  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BTN_CANCELAR'|translate}}
    <mat-icon class="ml-20">clear</mat-icon>
  </button>
</ng-container>
<ng-container *ngIf="datos.opcion == 'config'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_CONFI_PLAN'|translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <p><b>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_DATOS_PLAN'|translate}}</b></p>
    <p>
      <b>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_NOMB'|translate}}</b> {{datos.nombre}}<br>
      <b>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_SECC'|translate}}</b> {{datos.secciones}}<br>
      <b>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG'|translate}}</b> {{datos.preguntas}}
    </p>
    <p *ngIf="datos.modoAdmin == true"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_NOT_CONF_CONT_SECC'|translate}}</em> </p>
    <div class="mt-20" fxLayout="row" fxLayoutAlign="space-evenly stretch">
      <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="47" *ngIf="datos.modoAdmin == true">
        <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PERMI_SECC'|translate}}</p>
        <mat-list>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_AGRE_SECC_NEW'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.nuevasSecciones"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_MOVE_SECC'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.secMovibles"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_EDIT_TITU'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.secEditables"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_DELET_SECC'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.secEliminables"></mat-slide-toggle>
            </div>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_NOMB_OBL_GRUP_NEW'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.secNombresObligatorios"></mat-slide-toggle>
            </div>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_ENABLE_SEC_ESP'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.secEspeciales" (change)="cambiaStatusSecEsp($event.checked)"></mat-slide-toggle>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
      <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="47">
        <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PERMIS_PREG'|translate}} <b>{{'CERTIFICARV3.CATALOGOS.SECCIONES.' + datos.tipoSeccion | translate}}</b></p>
        <mat-list>
          <mat-list-item *ngIf="datos.modoAdmin == true">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_AGRE_PREG_NEW'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.nuevasPreguntas"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item *ngIf="datos.modoAdmin == true">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_AGRE_PREG_CATAL'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.preguntasMC"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item *ngIf="datos.modoAdmin == true">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_MOVE_PREGS'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.movibles"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item *ngIf="datos.modoAdmin == true">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_EDIT_PREG'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.editables"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item *ngIf="datos.modoAdmin == true">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_DELET_PREG'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.eliminables"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item *ngIf="datos.modoAdmin == true">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p *ngIf="datos.tipoSeccion != 6">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_NEW_MAX'|translate}}</p>
              <p *ngIf="datos.tipoSeccion == 6">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_NEW_MAX_4ALL'|translate}}</p>
              <mat-form-field>
                <mat-select [(ngModel)]="datos.configTemplate.limites.preguntasMaximas">
                  <mat-option *ngFor="let max of catalogoMaximos" [value]="max.valor">
                    {{max.titulo}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item *ngIf="datos.modoAdmin == true && datos.tipoSeccion == 6">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_REQUIRED'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.required4all"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item *ngIf="datos.configTemplate.audiosGlobal">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_ENABLE_AUDIOS'|translate}}</p>
              <mat-slide-toggle [(ngModel)]="datos.configTemplate.audios"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
        </mat-list>
      </div>
      <div *ngIf="false" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="30">
        <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_MAX_PREG_NEW'|translate}}</p>
        <mat-list>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_DEMOGRAF'|translate}}</p>
              <mat-form-field>
                <!-- <mat-label>Seleccione un número</mat-label> -->
                <mat-select [(ngModel)]="datos.configTemplate.limites.demograficos">
                  <mat-option *ngFor="let max of catalogoMaximos" [value]="max.valor">
                    {{max.titulo}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_ABIER'|translate}}</p>
              <mat-form-field>
                <!-- <mat-label>Seleccione un número</mat-label> -->
                <mat-select [(ngModel)]="datos.configTemplate.limites.abiertas">
                  <mat-option *ngFor="let max of catalogoMaximos" [value]="max.valor">
                    {{max.titulo}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PRAC4ALL'|translate}}</p>
              <mat-form-field>
                <!-- <mat-label>Seleccione un número</mat-label> -->
                <mat-select [(ngModel)]="datos.configTemplate.limites.forall">
                  <mat-option *ngFor="let max of catalogoMaximos" [value]="max.valor">
                    {{max.titulo}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
          <mat-list-item>
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_ADICIO'|translate}}</p>
              <mat-form-field>
                <!-- <mat-label>Seleccione un número</mat-label> -->
                <mat-select [(ngModel)]="datos.configTemplate.limites.adicionales">
                  <mat-option *ngFor="let max of catalogoMaximos" [value]="max.valor">
                    {{max.titulo}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-divider [inset]="true"></mat-divider>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </mat-dialog-content>
  <button mat-raised-button color="accent" class="mt-20" (click)="salirConfig()">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BTN_SAL'|translate}}
    <mat-icon class="ml-20">clear</mat-icon>
  </button>
</ng-container>
<ng-container *ngIf="datos.opcion == 'preguntaCat'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_INST_AGRE_PREG_CAT'|translate}}</h2>
  <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_BUSC_SELECC_PREG_PLAN'|translate}}</p>
  <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_VER_LIS_PREG_SELEC_3_PEST'|translate}}</p>
  <mat-dialog-content class="mat-typography">
    <mat-tab-group #stepsAgregar>
      <mat-tab label="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.TITULO_TAB_LIS_PREG'|translate}}">

        <div fxLayout="column" fxLayoutAlign="start stretch">
          <p class="mt-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_SELEC_PREG_LIS_CAT'|translate}}</p>
          <mat-form-field *ngIf="idiomaNativo">
            <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_SELEC_PREG'|translate}}</mat-label>
            <mat-select (selectionChange)="eligePreguntaCat($event.value)" [disabled]="arrayPreguntas.length >= datos.nuevasRestantes">
              <ng-container *ngFor="let pregunta of datos.catalogo;let i = index;">
                <ng-container *ngIf="pregunta.ocupada == false">
                  <ng-container *ngFor="let langPreg of pregunta.textVersions[0].questionLanguage;let j = index;">
                    <mat-option *ngIf="langPreg.lang == idiomaNativo" [value]="i">
                      {{langPreg.question}}
                    </mat-option>
                  </ng-container>
                </ng-container>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <h2 *ngIf="datos.nuevasRestantes == arrayPreguntas.length">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_YA_SELEC_NUM_MAX_PREG'|translate}}</h2>
          <div *ngIf="preguntaCatalogo" fxLayout="column" fxLayoutAlign="start stretch">
            <ng-container *ngIf="preguntaCatalogo.textVersions.length > 1 && !preguntaCatalogo.ocupada">
              <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_MS_UNA_VERS'|translate}}</em></p>
              <mat-form-field>
                <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_SELEC_VERS'|translate}}</mat-label>
                <mat-select (selectionChange)="eligeVersionPreguntaCat($event.value)">
                  <ng-container *ngFor="let version of preguntaCatalogo.textVersions;let j = index;">
                    <ng-container *ngFor="let idiomaVrs of version.questionLanguage;let k = index;">
                      <mat-option *ngIf="idiomaVrs.lang == idiomaNativo" [value]="{'versionSeleccionada':version.versionId, 'indiceVersion':j,'indiceTraduccion':k}">
                        {{idiomaVrs.question}}
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="versionPregunta != null">
              <mat-divider></mat-divider>
              <ng-container *ngIf="!preguntaCatalogo.ocupada">
                <p><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_SELECCIONDA'|translate}}</em></p>
                <p><b>{{ preguntaCatalogo.textVersions[versionPregunta].questionLanguage[indiceTraduccion].question }}</b></p>
              </ng-container>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <ng-container *ngIf="!preguntaCatalogo.ocupada">
                  <p>&nbsp;</p>
                  <button mat-raised-button color="primary" class="mt-20" (click)="agregaPreguntaCat()">
                    {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_AGRE_PREG'|translate}}
                    <mat-icon class="ml-20">add</mat-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="preguntaCatalogo.ocupada">
                  <div fxLayout="column" fxLayoutAlign="start stretch">
                    <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_OK_AGRE_PREG_LIST'|translate}}</p>
                    <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_OK_AGRE_PREG_LIST2'|translate}}</p>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

      </mat-tab>
      <mat-tab label="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.TITULO_TAB_BUSC_PREG'|translate}}">
        <mat-tab-group #stepsBuscar class="stepsBuscar">
          <mat-tab label="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.PASO_1'|translate}}">
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <p class="mt-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_ESCR_TEXT_BUSC'|translate}}</p>
              <div fxLayout="row" fxLayoutAlign="center stretch">
                <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BY_TEXT'|translate}}</p>
                <mat-slide-toggle [(ngModel)]="tipoBusqueda" (toggleChange)="limpiaBusqueda()" class="ml-20 mr-20"></mat-slide-toggle>
                <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BY_KEYWORDS'|translate}}</p>
              </div>
              <mat-form-field appearance="outline" *ngIf="!tipoBusqueda">
                <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.QUESTION_TEXT'|translate}}</mat-label>
                <input matInput [(ngModel)]="busqueda" (keyup)="buscaPregunta(1)" [disabled]="arrayPreguntas.length >= datos.nuevasRestantes">
              </mat-form-field>
              <mat-form-field appearance="outline" *ngIf="tipoBusqueda">
                <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.QUESTION_KEYWORDS'|translate}}</mat-label>
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let tag of searchTags" [selectable]="true" [removable]="true" (removed)="borraTag(tag)">
                    {{tag}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="agregaTag($event)">
                </mat-chip-list>
              </mat-form-field>
              <p><em [innerHTML]="'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.QUESTION_HINT'|translate"></em></p>

              <h2 *ngIf="datos.nuevasRestantes == arrayPreguntas.length">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_YA_SELEC_NUM_MAX_PREG'|translate}}</h2>
              <ng-container *ngIf="buscando">
                <div class="m-20" fxLayout="column" fxLayoutAlign="start center">
                  <mat-spinner diameter="40"></mat-spinner>
                  <h3><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_BUSC_PREG_COINC'|translate}}</em></h3>
                </div>
              </ng-container>
              <ng-container *ngIf="!buscando">
                <ng-container *ngIf="resultados">
                  <ng-container *ngIf="resultados.filteredData.length == 0">
                    <h3>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_NO_ENCO_PREG'|translate}}</h3>
                  </ng-container>
                  <ng-container *ngIf="resultados.filteredData.length > 0">
                    <p>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_RESUL_BUSC'|translate}}</p>
                    <table mat-table [dataSource]="resultados">

                      <ng-container matColumnDef="pregunta">
                        <th mat-header-cell *matHeaderCellDef>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG'|translate}}</th>
                        <td mat-cell *matCellDef="let element; let i = index;">
                          <div fxLayout="row" fxLayoutAlign="space-between center">
                            <ng-container *ngFor="let langPreg of element.textVersions[0].questionLanguage;let j = index;">
                              <ng-container *ngIf="langPreg.lang == idiomaNativo">
                                <p fxFlex>{{langPreg.question}}</p>
                                <button mat-flat-button color="primary" class="ml-20" (click)="preguntaBusqueda(element)" [disabled]="arrayPreguntas.length >= datos.nuevasRestantes">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BTN_ELEG'|translate}}</button>
                              </ng-container>
                            </ng-container>
                          </div>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="columnasResultado"></tr>
                      <tr mat-row *matRowDef="let row; columns: columnasResultado;"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>

                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </mat-tab>
          <mat-tab label="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.PASO_2'|translate}}">
            <div *ngIf="preguntaCatalogo" fxLayout="column" fxLayoutAlign="start stretch">
              <ng-container *ngIf="preguntaCatalogo.textVersions.length > 1 && !preguntaCatalogo.ocupada">
                <p class="mt-20"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_MS_UNA_VERS'|translate}}</em></p>
                <mat-form-field>
                  <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_SELEC_VERS'|translate}}</mat-label>
                  <mat-select (selectionChange)="eligeVersionPreguntaCat($event.value)">
                    <ng-container *ngFor="let version of preguntaCatalogo.textVersions;let j = index;">
                      <ng-container *ngFor="let idiomaVrs of version.questionLanguage;let k = index;">
                        <mat-option *ngIf="idiomaVrs.lang == idiomaNativo" [value]="{'versionSeleccionada':version.versionId, 'indiceVersion':j,'indiceTraduccion':k}">
                          {{idiomaVrs.question}}
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="versionPregunta != null">
                <mat-divider></mat-divider>
                <ng-container *ngIf="!preguntaCatalogo.ocupada">
                  <p class="mt-20"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_SELECCIONDA'|translate}}</em></p>
                  <p><b>{{ preguntaCatalogo.textVersions[versionPregunta].questionLanguage[indiceTraduccion].question }}</b></p>
                </ng-container>
              </ng-container>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-raised-button color="primary" class="mt-20" (click)="stepsBuscar.selectedIndex = 0">
                  {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_REGRE_RESUL'|translate}}
                  <mat-icon class="ml-20">arrow_back</mat-icon>
                </button>
                <ng-container *ngIf="versionPregunta != null && !preguntaCatalogo.ocupada">
                  <button mat-raised-button color="primary" class="mt-20" (click)="agregaPreguntaCatBusqueda()">
                    {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_AGRE_PREG'|translate}}
                    <mat-icon class="ml-20">add</mat-icon>
                  </button>
                </ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-tab>
      <mat-tab *ngIf="arrayPreguntas.length > 0 || (arrayPreguntas.length == 0 && stepsAgregar.selectedIndex == 2)" label="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.TITULO_TAB_PREG_SELEC'|translate}} ({{arrayPreguntas.length}})">
        <mat-tab-group #stepsVersion class="stepsBuscar">
          <mat-tab label="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.PASO_1'|translate}}">
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <p class="mt-20">{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_SELECC_MOMEN'|translate}}</p>
              <mat-list class="listaPreguntas" [id]="'lista0'" cdkDropList [cdkDropListData]="arrayPreguntas" [cdkDropListConnectedTo]="listasPreguntas" (cdkDropListDropped)="dropPregunta($event)">
                <mat-list-item class="pregunta" cdkDrag *ngFor="let pregunta of arrayPreguntas; last as last; let idxPreg = index;">
                  <div class="infoPregunta" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                    <button mat-icon-button class="mr-20" cdkDragHandle>
                      <mat-icon>menu</mat-icon>
                    </button>
                    <div fxFlex fxLayout="column" fxLayoutAlign="start stretch">
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <p fxFlex>
                          <ng-container *ngFor="let version of pregunta.preguntaCat.textVersions; let i = index;">
                            <ng-container *ngIf="version.versionId == pregunta.indiceVersion">
                              <ng-container *ngFor="let idiomaVers of version.questionLanguage; let j = index;">
                                <ng-container *ngIf="idiomaVers.lang == idiomaNativo">
                                  {{idiomaVers.question}}
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </p>
                        <div class="ml-20" fxLayout="row" fxLayoutAlign="space-between center">
                          <button *ngIf="pregunta.preguntaCat.textVersions.length > 1" mat-mini-fab class="botEdit mr-10" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.MAT_TOOL_ELEG_VERSI'|translate}}" (click)="cambiaVersionPregSel(1,idxPreg)">
                            <mat-icon>sync</mat-icon>
                          </button>
                          <button mat-mini-fab color="primary" matTooltip="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.MAT_TOOL_ELI_VERSI'|translate}}" (click)="borraPreguntaLista(pregunta.preguntaCat.idUnique)">
                            <mat-icon>delete_forever</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <mat-divider *ngIf="!last"></mat-divider>
                </mat-list-item>
              </mat-list>
            </div>
          </mat-tab>
          <mat-tab label="{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.PASO_2'|translate}}">
            <div *ngIf="preguntaCatalogo" fxLayout="column" fxLayoutAlign="start stretch">
              <ng-container *ngIf="preguntaCatalogo.textVersions.length > 1">
                <p class="mt-20"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_MS_UNA_VERS'|translate}}</em></p>
                <mat-form-field>
                  <mat-label>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_SELEC_VERS'|translate}}</mat-label>
                  <mat-select (selectionChange)="eligeVersionPreguntaCat($event.value)">
                    <ng-container *ngFor="let version of preguntaCatalogo.textVersions;let j = index;">
                      <ng-container *ngFor="let idiomaVrs of version.questionLanguage;let k = index;">
                        <mat-option *ngIf="idiomaVrs.lang == idiomaNativo" [value]="{'versionSeleccionada':version.versionId, 'indiceVersion':j,'indiceTraduccion':k}">
                          {{idiomaVrs.question}}
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="versionPregunta != null">
                <mat-divider></mat-divider>
                <ng-container *ngIf="!preguntaCatalogo.ocupada">
                  <p class="mt-20"><em>{{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.ETI_PREG_SELECCIONDA'|translate}}</em></p>
                  <p><b>{{ preguntaCatalogo.textVersions[versionPregunta].questionLanguage[indiceTraduccion].question }}</b></p>
                </ng-container>
              </ng-container>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-raised-button color="primary" class="mt-20" (click)="stepsVersion.selectedIndex = 0">
                  {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BTN_REGRES'|translate}}
                  <mat-icon class="ml-20">arrow_back</mat-icon>
                </button>
                <ng-container *ngIf="versionPregunta != null">
                  <button mat-raised-button color="primary" class="mt-20" (click)="cambiaVersionPregSel(2)">
                    {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BTN_ELIG_VERSI'|translate}}
                    <mat-icon class="ml-20">done</mat-icon>
                  </button>
                </ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <button mat-raised-button color="accent" class="mt-20" (click)="salirPregCat()">
    {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BTN_SAL'|translate}}
    <mat-icon class="ml-20">exit_to_app</mat-icon>
  </button>
</ng-container>
<ng-container *ngIf="datos.opcion == 'nuevoAudio'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.MODAL_AUDIO.TITULO.' + datos.tipo | translate}}</h2>
  <mat-dialog-content class="mat-typography">

    <mat-horizontal-stepper [linear]="false" [selectedIndex]="indicePasosAudio" (selectionChange)="cambioStep($event)" #stepper>
      <mat-step>
        <p>{{'CERTIFICARV3.MODAL_AUDIO.SUBTITULO' | translate}}</p>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" class="tac">
          <div fxLayout="column" fxLayoutAlign="start center" fxFlex="25">
            <h3>{{'CERTIFICARV3.MODAL_AUDIO.OPCIONES.GOOGLE' | translate}}</h3>
            <button mat-fab color="accent" matStepperNext (click)="tipoAudioSel = 1">
              <mat-icon>record_voice_over</mat-icon>
            </button>
          </div>
          <div fxLayout="column" fxLayoutAlign="start center" fxFlex="25">
            <h3>{{'CERTIFICARV3.MODAL_AUDIO.OPCIONES.RECORD' | translate}}</h3>
            <button mat-fab color="primary" matStepperNext (click)="tipoAudioSel = 2">
              <mat-icon>keyboard_voice</mat-icon>
            </button>
          </div>
          <div fxLayout="column" fxLayoutAlign="start center" fxFlex="25">
            <h3>{{'CERTIFICARV3.MODAL_AUDIO.OPCIONES.ARCHIVO' | translate}}</h3>
            <button mat-fab matStepperNext (click)="tipoAudioSel = 3">
              <mat-icon>arrow_upward</mat-icon>
            </button>
          </div>
        </div>
      </mat-step>
      <mat-step label="Fill out your address">
        <ng-container [ngSwitch]="tipoAudioSel">
          <ng-container *ngSwitchCase="1">
            <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.GOOGLE.TITULO' | translate}}</em></p>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <mat-form-field appearance="outline">
                <mat-label>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.GOOGLE.INPUT' | translate}}</mat-label>
                <textarea matInput [(ngModel)]="textoAudio" placeholder="{{'CERTIFICARV3.MODAL_AUDIO.PASOS.GOOGLE.INPUT_TT' | translate}}"></textarea>
                <mat-icon matSuffix>edit</mat-icon>
              </mat-form-field>
            </div>
            <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.GOOGLE.NOTA' | translate}}</em></p>
          </ng-container>
          <ng-container *ngSwitchCase="2">
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <h3>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.RECORD.TITULO' | translate}}</h3>
              <em class="mb-20">{{'CERTIFICARV3.MODAL_AUDIO.PASOS.RECORD.NOTA' | translate}}</em>
              <div fxLayout="column" fxLayoutAlign="start center" *ngIf="!recording">
                <button mat-fab color="accent" (click)="initiateRecording()">
                  <mat-icon>mic_none</mat-icon>
                </button>
                <h2>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.RECORD.START' | translate}}</h2>
              </div>
              <div fxLayout="column" fxLayoutAlign="start center" *ngIf="recording">
                <button mat-fab class="botGrabando" (click)="stopRecording()" matStepperNext>
                  <mat-icon>mic</mat-icon>
                </button>
                <h2>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.RECORD.STOP' | translate}}</h2>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="3">
            <div class="uploadfilecontainer" (click)="fileInput.click()" appDropFile (onFileDropped)="cargaAudio($event, 1)">
              <input type="file" #fileInput (change)="cargaAudio($event, 2)" accept=".mp3" hidden>
              <h1>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.ARCHIVO.INPUT' | translate}}</h1>
            </div>
            <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.ARCHIVO.NOTA' | translate}}</em></p>
          </ng-container>
        </ng-container>
        <div>
          <button mat-raised-button matStepperPrevious (click)="tipoAudioSel = 0">{{'CERTIFICARV3.MODAL_AUDIO.BOTONES.RESTART' | translate}}</button>
          <button mat-raised-button matStepperNext color="primary" class="ml-20" *ngIf="tipoAudioSel == 1 && textoAudio.length > 0" (click)="generandoAudio = true; DEMO_generaAudioTTS(textoAudio)">{{'CERTIFICARV3.MODAL_AUDIO.BOTONES.NEXT' | translate}}</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-container *ngIf="generandoAudio">
          <div fxLayout="column" fxLayoutAlign="start center">
            <h3>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.PREVIEW.GENERANDO' | translate}}</h3>
            <div class="spinnerCGO"></div>
          </div>
        </ng-container>
        <ng-container *ngIf="!generandoAudio">
          <h3>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.PREVIEW.TITULO' | translate}}</h3>
          <div fxLayout="column" fxLayoutAlign="start stretch">
            <audio autoplay controls="" *ngIf="url" class="w100">
              <source [src]="sanitize(url)" type="audio/wav">
              </audio>
            </div>
            <ul class="mt-20">
              <li>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.PREVIEW.NOTA_1' | translate}}</li>
              <li>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.PREVIEW.NOTA_2' | translate}}</li>
              <li>{{'CERTIFICARV3.MODAL_AUDIO.PASOS.PREVIEW.NOTA_3' | translate}}</li>
            </ul>
            <div>
              <button mat-raised-button (click)="stepper.reset()">{{'CERTIFICARV3.MODAL_AUDIO.BOTONES.RESTART' | translate}}</button>
              <button mat-raised-button color="accent" class="ml-20" (click)="DEMO_regresarPaso2()">{{'CERTIFICARV3.MODAL_AUDIO.BOTONES.BACK' | translate}}</button>
            </div>
        </ng-container>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'CERTIFICARV3.TAB_PREGUNTAS.DIALOG_MODAL.BTN_CANCELAR'|translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
    <button mat-raised-button color="primary" class="mt-20" (click)="salirNuevoAudio()" *ngIf="url">
      {{'CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
  </div>
</ng-container>
<ng-container *ngIf="datos.opcion == 'seccionEspecial'">
  <h2 mat-dialog-title>{{'CERTIFICARV3.MODAL_SEC_ESP.TITULO' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <p>{{'CERTIFICARV3.MODAL_SEC_ESP.SUBTITULO_1' | translate}}</p>
    <p>{{'CERTIFICARV3.MODAL_SEC_ESP.SUBTITULO_2' | translate}}</p>
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <div fxLayout="row" fxLayoutAlign="center center" class="p-20">
        <em>{{'CERTIFICARV3.MODAL_SEC_ESP.TIPOS.NORMAL' | translate}}</em>
        <mat-slide-toggle class="ml-20 mr-20" [(ngModel)]="tipoSeccion" [disabled]="datos.pasoCompleto" (change)="$event.checked == true ? datos.datosSeccion.typeCustom = 2 : datos.datosSeccion.typeCustom = 1"></mat-slide-toggle>
        <em>{{'CERTIFICARV3.MODAL_SEC_ESP.TIPOS.ESPECIAL' | translate}}</em>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="p-20">
        <mat-form-field appearance="outline" fxFlex="70">
          <mat-label>{{'CERTIFICARV3.MODAL_SEC_ESP.CAMPO.TITULO' | translate}}</mat-label>
          <input matInput name="claveSeccion" [(ngModel)]="datos.datosSeccion.tagCustom" [disabled]="datos.pasoCompleto" placeholder="{{'CERTIFICARV3.MODAL_SEC_ESP.CAMPO.TOOLTIP' | translate}}" maxlength="20">
          <mat-icon matSuffix>edit</mat-icon>
          <mat-hint>{{'CERTIFICARV3.MODAL_SEC_ESP.CAMPO.HINT' | translate}}</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <button mat-raised-button color="primary" class="mt-20" (click)="salirSeccionEsp()">
    {{'CERTIFICARV3.MODAL_SEC_ESP.CAMPO.ACEPTAR' | translate}}
    <mat-icon class="ml-20">done</mat-icon>
  </button>
</ng-container>
